export const ACCEPTED_PAYMENT_METHODS: string[] = [
  'Visa',
  'Maestro',
  'Mastercard',
  'Diners Club',
  'Discover',
  'JCB',
  'Mada',
];
